import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchExternalLinkIcon = (urls: string[]): Promise<any> =>
	performPostRequest('/gateway/api/object-resolver/resolve/batch', {
		body: JSON.stringify(
			urls.map((url) => ({
				resourceUrl: url,
			})),
		),
	}).then((response) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const results: { [key: string]: any } = {};
		urls.forEach((url, index) => {
			results[url] = response[index];
		});
		return results;
	});
